import { useTranslation } from 'react-i18next'

import type { Job } from '../../hooks/useFleet'
import type { User } from '../../hooks/useUsers'
import { SLAClock } from './SLAClock'

interface Props {
  jobs: Job[]
  users: User[]
}

/// Wave 1 E1.2 — Exception board. Pins delayed / at-risk / breached jobs
/// at the top of the dispatch console so the dispatcher always sees the
/// fires before the rest of the queue.
export function ExceptionBoard({ jobs, users }: Props) {
  const { t } = useTranslation()
  const byId = new Map(users.map((u) => [u.id, u]))

  return (
    <div className="px-4 py-2 bg-amber-50 border-b border-amber-200">
      <div className="text-xs font-semibold uppercase tracking-wide text-amber-700 mb-1">
        {t('dispatch.exceptions', 'Needs attention')} · {jobs.length}
      </div>
      <div className="flex gap-2 overflow-x-auto">
        {jobs.map((job) => (
          <div
            key={job.id}
            className="shrink-0 bg-white border border-amber-200 rounded-lg px-3 py-2 min-w-[220px]"
          >
            <div className="flex items-center justify-between gap-2">
              <div className="min-w-0">
                <div className="text-sm font-medium text-slate-900 truncate">
                  {job.customer_name || job.reference || job.id.slice(0, 8)}
                </div>
                <div className="text-xs text-slate-500 truncate">
                  {job.dropoff_address || job.pickup_address || '—'}
                </div>
                <div className="text-[11px] text-slate-500 mt-1">
                  {job.assigned_driver_id
                    ? (byId.get(job.assigned_driver_id)?.name ?? '—')
                    : t('dispatch.unassigned', 'Unassigned')}
                </div>
              </div>
              <SLAClock dueAt={job.sla_due_at ?? job.scheduled_at ?? null} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
